import type { VGSFormErrorMessages } from '../constants/vgsForm';
import { vgsFormErrorTranslationKeys } from '../constants/vgsForm';

export const getVGSErrorEntryTranslationKey = (
  errorMessage?: keyof typeof vgsFormErrorTranslationKeys,
): VGSFormErrorMessages | undefined => errorMessage && vgsFormErrorTranslationKeys[errorMessage];

export const mapVGSFormErrorMessagesToTranslationKeys = (
  formValues: Record<string, { errorMessages?: (keyof typeof vgsFormErrorTranslationKeys)[] }>,
): Record<string, { errorMessages: string[] }> =>
  Object.keys(formValues).reduce(
    (acc, k) => ({
      ...acc,
      [k]: {
        ...formValues[k],
        errorMessages: formValues[k]?.errorMessages?.map(getVGSErrorEntryTranslationKey) ?? [],
      },
    }),
    {},
  );
